(() => {
    frappe.ready(() => {
        const Orig = webshop.ProductList;
        if (!Orig) return;

        class ProductListPatched extends Orig {
            get_item_details(item, settings) {
                let details = super.get_item_details(item, settings);
                let bulk_html = item["bulk_prices_html"] || "";
                return details + `<div class="bulk-prices-wrapper">${bulk_html}</div>`;
            }
        }
        webshop.ProductList = ProductListPatched;
    });
})();
